import formFields from './formFields';
export default {
  [formFields.region.name]: 0,
  [formFields.district.name]: 1,
  [formFields.city.name]: 2,
  [formFields.locality.name]: 3,
  [formFields.street.name]: 4,
};
